<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="detailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">

        <h3 class="title">
          材料退库单
          <span style="margin-left:10px;position:relative;top:-3px;">
            <span v-if="!isMobile">
              <!-- 退库下载 -->
              <a v-if="backType==0"
                :href="baseURL + '/storage/material/back/download?backId=' + materialBackForceData.id" target="_blank">
                <!-- 负责人、审批人、管理员可以下载 -->
                <!-- SYSTEM_2 单独设置的下载权限 -->
                <el-button type="success" icon="el-icon-download" size="mini">表格下载</el-button>
              </a>
              <!-- 业务性退库下载 -->
              <a v-else
                :href="baseURL + '/storage/material/back/force/download?forceId=' + materialBackForceData.id" target="_blank">
                <!-- 负责人、审批人、管理员可以下载 -->
                <!-- SYSTEM_2 单独设置的下载权限 -->
                <el-button type="success" icon="el-icon-download" size="mini">表格下载</el-button>
              </a>
            </span>

            <!-- 打印 -->
            <el-button @click="print()" type="primary" icon="el-icon-printer" size="mini">打印格式</el-button>
          </span>
        </h3>


        <el-col :span="23" v-if="materialBackForceData">
          <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;">
            <el-form-item label="退库单号:">
              {{materialBackForceData.number}}
            </el-form-item>
            <el-form-item label="退库名称:" v-if="backType==1">
              {{ materialBackForceData.name }}
            </el-form-item>
            <el-form-item label="所属仓库:">
              <router-link class="link" target="_blank" :to="'/Storage/Detail/'+materialBackForceData.house.id">
                {{materialBackForceData.house.name}}
              </router-link>
            </el-form-item>
            <el-form-item v-if="backType==0 && materialBackForceData.projectName" label="所属工程:">
              <router-link class="link" target="_blank" :to="'/Project/Detail/'+materialBackForceData.projectId">
                {{materialBackForceData.projectName}}
              </router-link>
            </el-form-item>
            <el-form-item v-if="backType==0 && materialBackForceData.customer" label="客户:">
              {{ materialBackForceData.customer }}
            </el-form-item>

            <el-form-item label="退库人:">
              <user-info :userData='materialBackForceData.creator'></user-info>
            </el-form-item>
            <el-form-item label="退库时间:">
              {{materialBackForceData.time}}
            </el-form-item>
            <el-form-item v-if="backType==1" label="备注">
              {{materialBackForceData.remark}}
            </el-form-item>

            <el-form-item class="full" label="材料明细:">
              <div class="material-table">
                <el-table :summary-method="getSummaries" show-summary :data="materialBackForceData.materials" border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>

                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="单价(元)">
                    <template slot-scope="scope">
                      {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
                    </template>
                  </el-table-column>

                  <el-table-column prop="totalPrice" align="center" label="总价(元)">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>

          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    computed: {
      ...mapState({
        isMobile: state => state.main.isMobile,
      })
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,
      }
    },
    props: ['detailStatus', 'materialBackForceData', 'backType'],
    methods: {
      // 打印
      print() {
        let _type = this.backType == 0 ? 'materialBackA' : 'materialBackForce'
        let _printData = {
          type: _type,
          data: this.materialBackForceData,
          isPrint: true,
        }
        this.$store.commit('set_printData', _printData)
      },
      closeDetailStatus() {
        this.$emit("hideDetail")
      },
      // 合计
      getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        console.log(columns)
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return
          }
          if (index === 4 && this.materialBackForceData.number) {
            return
          }

          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/storage/components/materialBackForceDetail.vue